import { styled } from '@mui/material';

export const StyledContainer = styled('div')`
  width: 100%;
`;

export const StyledIFrame = styled('iframe')`
  width: 100%;
  height: 100%;
  border: none;
`;
